import type { ReactNode } from 'react'

// Иконки вкладок. Рисуем сами, чтобы не тянуть библиотеку ради трёх картинок
// и не ставить в интерфейс магазина эмодзи.
const Icon = ({ children }: { children: ReactNode }) => (
  <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {children}
  </svg>
)

export const CalendarIcon = () => (
  <Icon>
    <rect x="3" y="5" width="18" height="16" rx="3" />
    <path d="M3 10h18M8 3v4M16 3v4" />
  </Icon>
)

export const TagIcon = () => (
  <Icon>
    <path d="M12.6 3H20a1 1 0 0 1 1 1v7.4a2 2 0 0 1-.6 1.4l-7.6 7.6a2 2 0 0 1-2.8 0l-6-6a2 2 0 0 1 0-2.8l7.6-7.6a2 2 0 0 1 1.4-.6Z" />
    <circle cx="16.5" cy="7.5" r="1.2" />
  </Icon>
)

export const PlusIcon = () => (
  <Icon>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 8v8M8 12h8" />
  </Icon>
)
